import { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import useData from "../../hooks/useData";

const ControlledByDisplay = ({ value }) => {
  const { getMessage } = useLocalization();

  const { getFromServer, extractQuestions } = useData();

  const [controlQuestion, setControlledQuestion] = useState(null);

  useEffect(() => {
    if (!value) return;
    getData();
  }, [value]);

  const getData = async () => {
    if (!value?.questionId) return;

    const question = await getFromServer({
      entityName: "SurveyQuestion",
      id: value.questionId,
    });

    // console.log({ controlledQuestion: question });
    setControlledQuestion(question);
  };

  const optionsSelection = () => {
    if (!controlQuestion) return null;

    if (!value || !value.value) {
      return getMessage("noOptionsSelected");
    }

    let options = [];

    for (const optionValue of value.value) {
      const selectOption = controlQuestion.options.find(
        (opt) => opt.id === optionValue
      );
      if (selectOption) {
        options.push(selectOption.name);
      }
    }

    if (options.length === 0) {
      return getMessage("noOptionsSelected");
    }

    return options.join(", ");
  };

  return (
    <Box>
      <Typography sx={{ fontSize: "10px", fontWeight: 800 }}>
        {controlQuestion ? controlQuestion.name : getMessage("notSet")}
      </Typography>
      <Typography sx={{ fontSize: "10px" }}>{optionsSelection()}</Typography>
    </Box>
  );
};

export default ControlledByDisplay;
